import { fetcher } from 'services';
import { ContentsPostType } from '../types/enum/ContentsPostType';

const useShare = () => {
  return {
    // 회사 옆 맛집 게시판 공유
    shareTopEatsBoard: (data: ShareReqDto) => {
      return fetcher.topEatsBoards.shareTopEatsBoard(data);
    },
    // 고객 요청 사항으로 게시판명만 '<체력의 신> 챌린지' 으로 변경한 채 오픈 (2025. 08. 26)
    // '<체력의 신> 챌린지' 게시판 공유
    shareMentionsBoard: (data: ShareReqDto) => {
      return fetcher.mentionsBoards.shareMentionsBoard(data);
    },
    // 고객 요청 사항으로 독서 챌린지 오픈 (2026. 01. 06)
    // '독서 챌린지' 게시판 공유
    shareBookstoreBoard: (data: ShareReqDto) => {
      return fetcher.bookstoreBoards.shareBookstoreBoard(data);
    },
    // 회사 속 직무 게시판 공유
    shareDepartmentBoard: (data: ShareReqDto) => {
      return fetcher.departmentBoards.shareDepartmentBoard(data);
    },
    // 회사 밖 소모임 게시판 공유
    shareSocietyBoard: (data: ShareReqDto) => {
      return fetcher.societyBoards.shareSocietyBoard(data);
    },
    // 자유 게시판 공유
    shareBoard: (data: ShareReqDto) => {
      return fetcher.boards.shareBoard(data);
    },
    // LG LIFE 공지 게시판 공유
    shareAnnouncementBoard: (data: ShareReqDto) => {
      return fetcher.announcementBoards.shareAnnouncementBoard(data);
    },
    mediaShare: (data: ShareReqDto) => {
      return fetcher.media.putMediaShare(data);
    },
    eventShare: (data: ShareReqDto) => {
      return fetcher.event.postEventShare(data);
    },
    storyShare: (data: ShareReqDto) => {
      return fetcher.story.postStoryShare(data);
    },
    // 숏폼 미디어 공유
    shortsMediaShare: (data: ShareReqDto) => {
      return fetcher.shortsMedia.shareShortsMedia(data);
    },
    shareCount: (params: { contentsId: string; contentsPostType: string }) => {
      const _params = {
        ...params,
      } as CountAddReqDto;
      if (!params.contentsId) return;
      return fetcher.common.putShareCount(_params).then(res => res);
    },
  };
};

export default useShare;
